var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgSort = function SvgSort(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 26.724,
    viewBox: "0 0 18 26.724",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-1091 -218.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10144",
    "data-name": "Group 10144",
    transform: "translate(1091 227.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15961",
    "data-name": "Path 15961",
    d: "M0,0H18V18.112H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15962",
    "data-name": "Path 15962",
    d: "M9,4.528,4.5,0,0,4.528H9",
    transform: "translate(13.5 11.32) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10144-2",
    "data-name": "Group 10144",
    transform: "translate(1109 237) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15961-2",
    "data-name": "Path 15961",
    d: "M0,0H18V18.112H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15962-2",
    "data-name": "Path 15962",
    d: "M9,4.528,4.5,0,0,4.528H9",
    transform: "translate(13.5 11.32) rotate(180)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSort);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyNi43MjQiIHZpZXdCb3g9IjAgMCAxOCAyNi43MjQiPgogIDxnIGlkPSJHcm91cF8xMyIgZGF0YS1uYW1lPSJHcm91cCAxMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwOTEgLTIxOC44ODgpIj4KICAgIDxnIGlkPSJHcm91cF8xMDE0NCIgZGF0YS1uYW1lPSJHcm91cCAxMDE0NCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA5MSAyMjcuNSkiPgogICAgICA8cGF0aCBpZD0iUGF0aF8xNTk2MSIgZGF0YS1uYW1lPSJQYXRoIDE1OTYxIiBkPSJNMCwwSDE4VjE4LjExMkgwWiIgZmlsbD0ibm9uZSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF8xNTk2MiIgZGF0YS1uYW1lPSJQYXRoIDE1OTYyIiBkPSJNOSw0LjUyOCw0LjUsMCwwLDQuNTI4SDkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjUgMTEuMzIpIHJvdGF0ZSgxODApIi8+CiAgICA8L2c+CiAgICA8ZyBpZD0iR3JvdXBfMTAxNDQtMiIgZGF0YS1uYW1lPSJHcm91cCAxMDE0NCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEwOSAyMzcpIHJvdGF0ZSgxODApIj4KICAgICAgPHBhdGggaWQ9IlBhdGhfMTU5NjEtMiIgZGF0YS1uYW1lPSJQYXRoIDE1OTYxIiBkPSJNMCwwSDE4VjE4LjExMkgwWiIgZmlsbD0ibm9uZSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF8xNTk2Mi0yIiBkYXRhLW5hbWU9IlBhdGggMTU5NjIiIGQ9Ik05LDQuNTI4LDQuNSwwLDAsNC41MjhIOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMuNSAxMS4zMikgcm90YXRlKDE4MCkiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";